import {HttpStatusCode} from 'axios';
import {DisplayMessage, Result, WeddingOccasionDB, WeddingOccasionDTO} from '../lib/interfaces';
import {getFirstAvailableApi, getWeddingOccasionsApi} from './apiServices';
import {DisplayMessageTypes} from '../lib/enums';

export async function getFirstAvailable(startTime: string): Promise<Result<WeddingOccasionDTO, DisplayMessage>> {
  const response = await getFirstAvailableApi(startTime);
  if (response.status === HttpStatusCode.Ok) {
    return {
      data: {
        id: response.data.id,
        location: response.data.location,
        time: response.data.time,
        weddingOfficiantName: response.data.weddingOfficiant.name,
        booking: response.data.booking,
      } as WeddingOccasionDTO,
      info: null,
    } as Result<WeddingOccasionDTO, DisplayMessage>;
  } else {
    return {
      data: null,
      info: {type: DisplayMessageTypes.Error, message: response.message},
    } as Result<WeddingOccasionDTO, DisplayMessage>;
  }
}

export async function getWeddingOccasions(): Promise<Result<WeddingOccasionDB[], DisplayMessage>> {
  const response = await getWeddingOccasionsApi();
  if (response.status === HttpStatusCode.Ok) {
    return {
      data: response.data,
      info: null,
    } as Result<WeddingOccasionDB[], DisplayMessage>;
  } else {
    return {
      data: null,
      info: {
        type: DisplayMessageTypes.Error,
        message: 'INTERNAL_ERROR',
        visible: true,
      },
    } as Result<WeddingOccasionDB[], DisplayMessage>;
  }
}
